import { cn } from 'cn';

/** Barra em blocos (N/`total` preenchidos), não contínua — decisão explícita sobre o `<Progress>` liso. */
export function SegmentedProgress({
  total,
  preenchido,
  className,
}: {
  total: number;
  preenchido: number;
  className?: string;
}) {
  return (
    <div className={cn('flex items-center gap-3', className)}>
      <div className="flex flex-1 gap-1">
        {Array.from({ length: total }).map((_, indice) => (
          <div
            key={indice}
            className={cn(
              'h-2 w-6 shrink-0 rounded-full',
              indice < preenchido ? 'bg-primary' : 'bg-slate-200',
            )}
          />
        ))}
      </div>
      <span className="shrink-0 text-xs font-semibold text-slate-600">
        {preenchido}/{total}
      </span>
    </div>
  );
}
